import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { ACCESS_TOKEN } from '../../util/constants/APP_RESERVED_NAME'
import { APP_URL } from '../../util/constants/APP_URL'
import { getCookie } from '../../util/storage/cookies'

const ProtectedPublicRoute = () => {
  const auth = getCookie(ACCESS_TOKEN)

  return auth === ''
    ? (
    <Outlet />
      )
    : (
    <Navigate to={APP_URL.DASHBOARD.HOME} />
      )
}

export default ProtectedPublicRoute
